import { useRef, useEffect } from 'react';

function SteamTrail({ active }) {
  const canvasRef = useRef(null);
  const particles = useRef([]);
  const mouse = useRef({ x: 0, y: 0 });
  const animationRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    window.addEventListener('resize', resize);

    const onMouseMove = (e) => {
      mouse.current = { x: e.clientX, y: e.clientY };

      if (!active) return;

      const count = Math.random() < 0.5 ? 1 : 2;
      for (let i = 0; i < count; i++) {
        const angle = Math.random() * Math.PI * 2;
        const spread = Math.random() * 6;
        particles.current.push({
          x: mouse.current.x + Math.cos(angle) * spread,
          y: mouse.current.y + Math.sin(angle) * spread,
          size: Math.random() * 14 + 8,
          speedX: (Math.random() - 0.5) * 0.6,
          speedY: -(Math.random() * 0.5 + 0.2),
          opacity: Math.random() * 0.18 + 0.06,
          grow: Math.random() * 0.4 + 0.15,
        });
      }
    };

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      particles.current = particles.current.filter(p => p.opacity > 0.004);

      particles.current.forEach(p => {
        p.x += p.speedX;
        p.y += p.speedY;
        p.speedX += (Math.random() - 0.5) * 0.08;
        p.size  += p.grow;
        p.opacity -= 0.004;

        const grad = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.size);
        grad.addColorStop(0,   `rgba(210, 220, 240, ${p.opacity})`);
        grad.addColorStop(0.5, `rgba(190, 205, 230, ${p.opacity * 0.5})`);
        grad.addColorStop(1,   `rgba(180, 195, 220, 0)`);

        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fillStyle = grad;
        ctx.fill();
      });

      animationRef.current = requestAnimationFrame(animate);
    };

    document.addEventListener('mousemove', onMouseMove);
    animate();

    return () => {
      document.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('resize', resize);
      cancelAnimationFrame(animationRef.current);
    };
  }, [active]);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        pointerEvents: 'none',
        zIndex: 9998,
      }}
    />
  );
}

export default SteamTrail;
